import { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';
import { Button } from '@/components/common/Button/Button';

interface Hero2ColumnProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  subtext: string;
  image?: string;
  tag?: string;
  tagHref?: string;
  buttonText?: string;
  buttonHref?: string;
  secondaryButtonText?: string;
  secondaryButtonHref?: string;
}

export const Hero2Column = ({
  title,
  subtext,
  image = '/images/hero/placeholder.jpg',
  tag,
  tagHref = '#',
  buttonText,
  buttonHref,
  secondaryButtonText,
  secondaryButtonHref,
  className,
  ...props
}: Hero2ColumnProps) => {
  return (
    <section className={cn('py-20 bg-gray-50', className)} {...props}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="max-w-xl">
            {tag && (
              <a
                href={tagHref}
                className="inline-flex items-center rounded-full bg-primary-50 px-3 py-1 md:px-4 md:py-1.5 text-xs md:text-sm font-medium text-primary-600 transition-colors hover:bg-primary-100 mb-4 md:mb-6"
              >
                <span className="relative">{tag}</span>
              </a>
            )}
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {title}
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed mb-8">
              {subtext}
            </p>
            <div className="flex flex-wrap gap-4">
              {buttonText && buttonHref && (
                <Button
                  variant="solid"
                  color="primary"
                  onClick={() => window.open(buttonHref, "_blank")}
                >
                  {buttonText}
                </Button>
              )}
              {secondaryButtonText && secondaryButtonHref && (
                <Button
                  variant="gradient"
                  color="primary"
                  onClick={() => window.open(secondaryButtonHref, "_blank")}
                >
                  {secondaryButtonText}
                </Button>
              )}
            </div>
          </div>
          <div className="relative h-[350px] md:h-[450px] lg:h-[550px] rounded-2xl overflow-hidden">
            <div className="absolute inset-0 " />
            <img
              src={image}
              alt="Hero"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};